/**
 * Created by fworld on 2019/7/24.
 */
export default {
    title: {
        text: '异常占比',
        x: 'center',
        show: "false",
        top: '0',
        left: '25%',
        textStyle: {
            color: '#c2c2c2'
        }
    },
    grid: {
        left: '8%',
        top: '0',
        containLabel: true
    },
    tooltip: {
        trigger: 'item',
        formatter: '{a} <br/>{b} : {c} ({d}%)'
    },
    legend: {
        type: 'scroll',
        orient: 'vertical',
        right: 0,
        data: ['系统缺水', '系统压力过大', '冲泡器自检', '分向阀自检', '温度过高', '环境温度过低', '豆盒未安装到位', '粉料盒未安装到位',
            '冲泡器未安装到位', 'HMI通信异常', '咖啡电热盘加热超时', '蒸汽电热盘加热超时', '热水锅炉加热超时', '咖啡电热盘NTC异常',
            '蒸汽电热盘NTC异常', '热水锅里NTC异常', '电热盘供水异常', '热水锅炉供水异常', '冲煮系统异常', '分向阀异常', '磨豆机异常',
            '冰箱通信异常'],
        textStyle: {
            color: '#c2c2c2',
            fontSize: '12px',
        },
        pageStyle: {
            color: '#333',
            fontSize: '12px',
        }
    },
    series: [
        {
            name: '异常类型',
            type: 'pie',
            radius: ['24%', '48%'],
            center: ['36%', '50%'],
            avoidLabelOverlap: false,
            label: {
                normal: {
                    show: true,
                    fontSize: '12'
                },
                emphasis: {
                    show: true,
                    fontSize: '12'
                }
            },
            labelLine: {
                normal: {
                    show: true
                }
            },
            data: [
                {value: 335, name: '系统缺水'},
                {value: 310, name: '系统压力过大'},
                {value: 234, name: '冲泡器自检'},
                {value: 135, name: '分向阀自检'},
                {value: 1548, name: '温度过高'},
                {value: 1548, name: '环境温度过低'},
                {value: 1548, name: '豆盒未安装到位'},
                {value: 1548, name: '粉料盒未安装到位'},
                {value: 1548, name: '冲泡器未安装到位'},
                {value: 1548, name: 'HMI通信异常'},
                {value: 1548, name: '咖啡电热盘加热超时'},
                {value: 1548, name: '蒸汽电热盘加热超时'},
                {value: 1548, name: '热水锅炉加热超时'},
                {value: 1548, name: '咖啡电热盘NTC异常'},
                {value: 1548, name: '蒸汽电热盘NTC异常'},
                {value: 1548, name: '热水锅里NTC异常'},
                {value: 1548, name: '电热盘供水异常'},
                {value: 1548, name: '热水锅炉供水异常'},
                {value: 1548, name: '冲煮系统异常'},
                {value: 1548, name: '分向阀异常'},
                {value: 1548, name: '磨豆机异常'},
                {value: 1548, name: '冰箱通信异常'},
            ],
            itemStyle: {
                emphasis: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
            }
        }
    ]
}
